export default "__VITE_ASSET__djalGdYE__"